import { render, staticRenderFns } from "./ProjectsDuration.vue?vue&type=template&id=ce4d1506&"
import script from "./ProjectsDuration.vue?vue&type=script&lang=js&"
export * from "./ProjectsDuration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports